import { isNotNullOrUndefined } from 'in-time-core';
import { ICloudFunctionsProvider } from './cloud-functions-provider.js';
import { HttpsAuthContext, HttpsCallable } from './https-callable.js';
import { HttpClient } from './https-client.js';

export class GCPCloudFunctionsProvider implements ICloudFunctionsProvider {
  private readonly httpClient: HttpClient;
  private readonly gcpServiceUrl: string;
  private readonly appId: string;
  private readonly buildId: number | null;
  private readonly operatingSystem: string;
  private emulatorOrigin: string | null = null;

  constructor(args: {
    httpClient: HttpClient,
    gcpServiceUrl: string,
    appId: string,
    buildId: number | null,
    operatingSystem: string,
  }) {
    this.httpClient = args.httpClient;
    this.gcpServiceUrl = args.gcpServiceUrl;
    this.appId = args.appId;
    this.buildId = args.buildId;
    this.operatingSystem = args.operatingSystem;
  }

  getHttpsCallable(functionName: string, context: HttpsAuthContext): HttpsCallable {
    if(isNotNullOrUndefined(this.emulatorOrigin)) {
      return new HttpsCallable(
          this.httpClient,
          `${this.emulatorOrigin}/${functionName}`,
          context,
          {
            'appId': this.appId,
            'buildId': this.buildId,
            'operatingSystem': this.operatingSystem,
          }
      );
    }
    else {
      return new HttpsCallable(
          this.httpClient,
          `${this.gcpServiceUrl}/${functionName}`,
          context,
          {
            'appId': this.appId,
            'buildId': this.buildId,
            'operatingSystem': this.operatingSystem,
          }
      );
    }
  }

  useFunctionsEmulator(origin: string): void {
    this.emulatorOrigin = origin;
  }
}
